import { FullPageLoader, useToast } from '@color/continuum';
import { loggerUtils } from '@color/lib';
import { Redirect, Route, Switch } from 'react-router-dom';

import { ConversationCreateView } from './ConversationCreate/ConversationCreateView';
import { ConversationDetailView } from './ConversationDetailView/ConversationDetailView';
import {
  PATIENT_MESSAGING_CONVERSATION_CREATE_PATH,
  PATIENT_MESSAGING_CONVERSATION_DETAIL_PATH,
  PATIENT_MESSAGING_INBOX_PATH,
} from './paths';
import { PatientMessagingInbox } from './PatientMessagingInbox';
import { usePatientMessagingLogin } from './usePatientMessagingLogin';

export const Routes: React.FC = () => {
  const { showErrorToast } = useToast();
  const { isLoading, patientIsNotOnboarded, isSmoochLoginError, initError, loginError } =
    usePatientMessagingLogin();

  if (patientIsNotOnboarded) {
    return <Redirect to="/" />;
  }

  // TODO: Add better error handling here (consider using the delegate methods on the SDK).
  // Ideally we'd keep our `Routes` file a bit less complicated (less API calls and waiting), but
  // given our component hierarchy, this was the only place we could initialize the Smooch SDK.
  // Our direct parent (PatientMessagingPortal.tsx) sets the `div` that will be used for rendering,
  // which must be a component higher than the `render` call. A individual routes themselves (Inbox
  // and ConversationDetailView) don't work because patients may navigate between them, calling
  // the init method multiple times which causes an error.
  if (isSmoochLoginError) {
    showErrorToast('There was an issue loading your inbox.');
    loggerUtils.logException(
      new Error(
        `Failed to log patient in to messaging: isSmoochLoginError=${isSmoochLoginError} initError=${initError?.message} loginError=${loginError?.message}`
      )
    );
  }
  if (isLoading) {
    return <FullPageLoader />;
  }

  return (
    <Switch>
      <Route exact path={PATIENT_MESSAGING_INBOX_PATH}>
        <PatientMessagingInbox />
      </Route>
      <Route path={PATIENT_MESSAGING_CONVERSATION_CREATE_PATH}>
        <ConversationCreateView />
      </Route>
      <Route path={PATIENT_MESSAGING_CONVERSATION_DETAIL_PATH}>
        <ConversationDetailView />
      </Route>
      <Redirect to={PATIENT_MESSAGING_INBOX_PATH} />
    </Switch>
  );
};
